import { Box, Grid, type GridProps, Text } from "@chakra-ui/react";
import { Bullets } from "components/bullets";
import React from "react";

type ProsConsTableProps = GridProps & {
  variant: "green" | "gray";
  pros: string[];
  cons: string[];
};

export function MdxProsConsList({ variant, pros, cons, ...props }: ProsConsTableProps) {
  const prosBgColor = `${variant}.100`;

  return (
    <Grid
      templateColumns={{ base: "auto", md: "1fr 1fr" }}
      templateRows={{ base: "min-content min-content", md: "auto" }}
      {...props}
    >
      <Box bgColor={prosBgColor} borderRadius="md" px="8" py="8">
        <Text fontWeight="semibold" fontSize="lg" mb="5">
          Pros
        </Text>
        <Bullets textAlign="left" items={pros} px="5" spacing="6" fontSize="md" />
      </Box>

      <Box borderRadius="md" px="8" py="8">
        <Text fontWeight="semibold" fontSize="lg" mb="5">
          Cons
        </Text>
        <Bullets textAlign="left" items={cons} px="5" spacing="6" fontSize="md" />
      </Box>
    </Grid>
  );
}
